import { Globe } from "lucide-react";

const LINKS: Record<string, string> = {
  // Services
  "AI Integration":        "/services/ai-integration.html",
  "Custom AI Products":    "/services/custom-products.html",
  "Consultancy":           "/services/ai-consultancy.html",
  "Defence-Ready":         "/services/defence-audits.html",
  "Policy Generation":     "/services/policy-generation.html",
  "AI App Rescue":         "/#rescue",
  "Managed Support":       "/#contact",
  "Engineering Squads":    "/services/engineering-squads.html",
  // Industries
  "Mining & Resources":    "/industries/mining.html",
  "Heavy Machinery":       "/industries/machinery.html",
  "GIS & Geospatial":      "/industries/gis.html",
  "Data Analytics":        "/blog/posts/wa-mining-sovereign-software.html",
  // Company
  "About":                 "/#about",
  "Insights":              "/blog.html",
  "Case Studies":          "/#cases",
  "Careers":               "/#contact",
  "Contact":               "/#contact",
};

const cols = [
  { title: "Services",   links: ["AI Integration", "Custom AI Products", "Consultancy", "Defence-Ready", "Policy Generation", "AI App Rescue", "Managed Support", "Engineering Squads"] },
  { title: "Industries", links: ["Mining & Resources", "Heavy Machinery", "GIS & Geospatial", "Data Analytics"] },
  { title: "Company",    links: ["About", "Insights", "Case Studies", "Careers", "Contact"] },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black border-t border-white/10 px-6 pt-20 pb-10 relative">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-10 mb-16">
          <div>
            <a href="/" className="flex items-center gap-2 text-white font-semibold text-lg hover:text-white/80 transition-colors">
              <Globe size={24} />
              <span>Paisums</span>
            </a>
            <p className="text-white/55 text-sm leading-relaxed mt-5 max-w-xs">
              Pioneers of the AI revolution in industry. AI-driven products and defence-ready systems for mining, machinery, GIS and data analytics. AU · NZ · Worldwide.
            </p>
            <div className="flex gap-2 mt-5 flex-wrap">
              {["NZ · 2021", "AI-native", "Senior squads", "1 business-day reply"].map((t) => (
                <span key={t} className="liquid-glass rounded-full px-3 py-1 text-white/70 text-[10px] tracking-widest uppercase">{t}</span>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-white/40 text-[11px] tracking-widest uppercase mb-4">{c.title}</div>
              <div className="flex flex-col gap-2">
                {c.links.map((l) => (
                  <a key={l} href={LINKS[l] ?? "#"} className="text-white/75 hover:text-white text-sm transition-colors">{l}</a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="hairline mb-6" />
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 text-white/40 text-xs">
          <span>© {year} Paisums Technology. Crafted in Auckland · Perth · everywhere.</span>
          <span className="flex gap-5">
            <a href="/privacy.html" className="hover:text-white/80">Privacy</a>
            <a href="/terms.html" className="hover:text-white/80">Terms</a>
            <a href="/services/defence-audits.html" className="hover:text-white/80">Defence-ready statement</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
